exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-500{font-weight:500}#ItemCreationValidationModalEdit .modal-dialog,#ItemCreationValidationModalView .modal-dialog{min-width:80%}", ""]);

// exports
